import type { AppLanguage } from "./app/language";

export const archiveRetentionMonthOptions = [3, 6, 12, 18, 24] as const;

export function normalizeArchiveRetentionMonths(value: unknown, fallback: number | null = null) {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }

  const numericValue = typeof value === "number" ? value : Number.parseInt(String(value), 10);

  if (!Number.isFinite(numericValue) || !Number.isInteger(numericValue)) {
    return fallback;
  }

  if (numericValue <= 0 || numericValue > 24) {
    return fallback;
  }

  return numericValue;
}

export function formatArchiveRetentionMonthsLabel(months: number, language: AppLanguage = "en") {
  if (language === "ja") {
    if (months === 1) {
      return "1 か月";
    }

    if (months % 12 === 0) {
      const years = months / 12;
      return `${years} 年`;
    }

    return `${months} か月`;
  }

  if (months === 1) {
    return "1 month";
  }

  if (months % 12 === 0) {
    const years = months / 12;
    return `${years} year${years === 1 ? "" : "s"}`;
  }

  return `${months} months`;
}
